import { useMemo } from "react"
import { useFeatureFlagEnabled } from "posthog-js/react"
import { FeatureFlag } from "../enums/featureFlags"
import { ProviderStatusDisplayIdEnum, ProviderStatusDisplayId } from "./schema"
import { useSelector } from "react-redux"
import { userCanEditProvider } from "../Account/userSlice"
import { selectProvider } from "./model"
import { selectHasPracticeCreationInProgress } from "../Practices/selectors"

export const useIsOrphanedProvider = (providerStatusDisplayId?: string) => {
  const isProviderOrphanSupportEnabled = useFeatureFlagEnabled(
    FeatureFlag.IsProviderOrphanSupport16529Enabled,
  )
  const hasPracticeCreationInProgress = useSelector(
    selectHasPracticeCreationInProgress,
  )

  const isOrphaned = Boolean(
    isProviderOrphanSupportEnabled &&
    providerStatusDisplayId === ProviderStatusDisplayIdEnum.ORPHANED,
  )

  return {
    isOrphaned,
    isPracticeCreationInProgress: isOrphaned && hasPracticeCreationInProgress,
  }
}

export const useUserCanEditProvider = (
  providerProfileStatus: ProviderStatusDisplayId,

  _providerId: string | undefined,
) => {
  const { isOrphaned } = useIsOrphanedProvider(providerProfileStatus)
  const provider = useSelector(selectProvider)
  const providerUserId = provider?.userId

  const selector = useMemo(
    () =>
      userCanEditProvider(providerProfileStatus, providerUserId, isOrphaned),
    [providerProfileStatus, providerUserId, isOrphaned],
  )
  return useSelector(selector)
}
